<template>
  <b-modal
    ref="sequenceModal"
    title="Get Sequences"
    @hide="resetSelections"
    :hide-footer="true"
  >
    <b-form-group label="Select Option:" label-for="sequence-select">
      <b-form-select
        id="sequence-select"
        :options="options"
        v-model="selectedOption"
        @change="onOptionChange"
      ></b-form-select>
    </b-form-group>

    <b-form-group label="Choose Format:">
      <div class="d-block" v-for="option in formatOptions" :key="option.value">
        <b-form-radio
          v-model="selectedFormat"
          :value="option.value"
          :disabled="isFormatSelectionDisabled || option.disabled"
        >
          {{ option.text }}
        </b-form-radio>
      </div>
    </b-form-group>

    <b-button variant="primary" @click="submitSelection">Submit</b-button>
  </b-modal>
</template>

<script>
export default {
  props: {
    geneList: {
      type: Array,
      default: () => [],
    },
    geneListType: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      options: [
        { value: "TAIR12_cdna", text: "TAIR12 transcripts" },
        { value: "TAIR12_cds", text: "TAIR12 coding sequences" },
        {
          value: "TAIR12_seq",
          text: "TAIR12 genomic locus sequences",
        },
        {
          value: "TAIR12_pep",
          text: "TAIR12 protein sequences",
        },
        {
          value: "TAIR12_upstream_500",
          text: "TAIR12 Loci Upstream Seq - 500bp",
        },
        {
          value: "TAIR12_upstream_1000",
          text: "TAIR12 Loci Upstream Seq - 1000bp",
        },
        {
          value: "TAIR12_upstream_3000",
          text: "TAIR12 Loci Upstream Seq - 3000bp",
        },
        {
          value: "TAIR12_downstream_500",
          text: "TAIR12 Loci Downstream Seq - 500bp",
        },
        {
          value: "TAIR12_downstream_1000",
          text: "TAIR12 Loci Downstream Seq - 1000bp",
        },
        {
          value: "TAIR12_downstream_3000",
          text: "TAIR12 Loci Downstream Seq - 3000bp",
        },
        {
          value: "TAIR12_intergenic",
          text: "TAIR12 Intergenic Sequences",
        },
        { value: "TAIR12_intron", text: "TAIR12 Intron Sequences" },
        { value: "TAIR12_3_utr", text: "TAIR12 3' UTRs" },
        { value: "TAIR12_5_utr", text: "TAIR12 5' UTRs" },
      ],
      selectedOption: "TAIR12_cdna",
      selectedFormat: "rep_gene",
      formatOptions: [
        {
          value: "rep_gene",
          text: "Get one sequence per locus (representative gene model/splice form only)",
        },
        {
          value: "both",
          text: "Get sequences for all gene models/splice forms",
        },
        {
          value: "genemodel",
          text: "Get sequences for only the gene model/splice form matching my query",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    // Options with one record per gene model. TAIR12_seq is per locus (its
    // rep_gene and genemodel files are the same file), so a gene model ID
    // matches nothing there and the format choice does not apply.
    isFormatSelectionDisabled() {
      return ![
        "TAIR12_cdna",
        "TAIR12_cds",
        "TAIR12_pep",
        "TAIR12_5_utr",
        "TAIR12_3_utr",
        "TAIR12_intron",
      ].includes(this.selectedOption);
    },

    isGeneModelOptionEnabled() {
      return this.geneList.length > 0 && this.geneListType === "AGI Gene IDs";
    },
  },
  watch: {
    isGeneModelOptionEnabled: {
      immediate: true,
      handler(newValue) {
        this.formatOptions = this.formatOptions.map((option) => {
          if (option.value === "genemodel") {
            return { ...option, disabled: !newValue };
          }
          return option;
        });

        if (!newValue && this.selectedFormat === "genemodel") {
          this.selectedFormat = "rep_gene";
        }
      },
    },
  },
  methods: {
    show() {
      this.$nextTick(() => {
        if (this.isGeneModelOptionEnabled) {
          this.selectedFormat = "genemodel";
        } else {
          this.selectedFormat = "rep_gene";
        }
        this.$refs.sequenceModal.show();
      });
    },
    hide() {
      this.$refs.sequenceModal.hide();
    },
    resetSelections() {
      this.selectedOption = "TAIR12_cdna";
      this.selectedFormat = this.isGeneModelOptionEnabled
        ? "genemodel"
        : "rep_gene";
    },
    onOptionChange() {
      if (this.isFormatSelectionDisabled) {
        this.selectedFormat = "rep_gene";
      }
    },
    submitSelection() {
      this.$emit("submit", {
        option: this.selectedOption,
        format: this.selectedFormat,
      });
      this.hide();
    },
  },
};
</script>

<style scoped>
.custom-select {
  border-color: #6c757d; /* Gray-600 */
}
</style>
